import { ItemUnavailabilityIntervalEnum } from './updateOrderStatus';
import { client } from './client';
import { endpoints } from './endpoints';

export type ItemAvailabilityData = {
  itemUUID: string;
  availability: boolean;
  unavailabilityIntervalEnum?: ItemUnavailabilityIntervalEnum | string;
};

export async function changeItemAvailability(
  branchUUID: string,
  data: ItemAvailabilityData,
): Promise<void> {
  const response = await client.put(
    endpoints.ITEM_AVAILABILITY(branchUUID),
    data,
  );
  return response.data;
}

export async function changeBulkItemsAvailability(
  branchUUID: string,
  itemsData: ItemAvailabilityData[],
): Promise<PromiseSettledResult<any>[]> {
  const allRequests: Promise<any>[] = [];
  itemsData.map((item: ItemAvailabilityData) => {
    return allRequests.push(
      client.put(endpoints.ITEM_AVAILABILITY(branchUUID), item),
    );
  });

  return Promise.allSettled(allRequests);
}
